import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { listClients } from "../../api/minisite";
import HelpLink, { GUIDE_URLS } from "@/components/HelpLink";

const STATUS_LABELS = {
  not_started: { label: "Pas commencé", color: "#999" },
  draft: { label: "Brouillon", color: "#f59e0b" },
  outdated: { label: "Modifié", color: "#ef4444" },
  published: { label: "Publié", color: "#10b981" },
};

export default function MinisiteDashboard({ onBackToDashboard }) {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const out = await listClients();
        setClients(out);
      } catch (e) {
        setError(e?.response?.data?.detail || e.message);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) return <div style={{ padding: 40 }}>Chargement...</div>;
  if (error) return <div style={{ padding: 40, color: "red" }}>{error}</div>;

  const handleBackToDashboard = () => {
    if (onBackToDashboard) onBackToDashboard();
    navigate("/");
  };

  return (
    <div className="minisite-module-page" style={{ padding: 40, maxWidth: 900, margin: "0 auto" }}>
      <div className="module-header" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 16, marginBottom: 24 }}>
        <div className="module-title" style={{ display: "flex", alignItems: "center", minWidth: 0 }}>
          <button onClick={handleBackToDashboard}>← Tableau de bord</button>
          <h1 style={{ marginLeft: 16 }}>Module Minisites</h1>
        </div>
        <div className="module-header-actions">
          <HelpLink url={GUIDE_URLS.minisite} />
        </div>
      </div>
      {clients.length === 0 && <p>Aucun client trouvé.</p>}
      <ul style={{ listStyle: "none", padding: 0 }}>
        {clients.map((c) => {
          const s = STATUS_LABELS[c.minisite_status] || STATUS_LABELS.not_started;
          return (
            <li
              key={c.client_id}
              onClick={() => navigate(`/minisite/${c.client_id}`)}
              style={{
                padding: 16,
                border: "1px solid #eee",
                borderRadius: 8,
                marginBottom: 8,
                cursor: "pointer",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <strong>{c.name}</strong>
                <div style={{ fontSize: 12, color: "#666" }}>
                  {c.has_autobio ? "✓ Autobio" : "○ Autobio"} ·{" "}
                  {c.has_bds ? "✓ BDs validées" : "○ BDs"}
                </div>
              </div>
              <div>
                <span
                  style={{
                    background: s.color,
                    color: "white",
                    padding: "4px 10px",
                    borderRadius: 12,
                    fontSize: 12,
                  }}
                >
                  {s.label}
                </span>
                {c.live_url && (
                  <a
                    href={c.live_url}
                    target="_blank"
                    rel="noreferrer"
                    onClick={(e) => e.stopPropagation()}
                    style={{ marginLeft: 12, fontSize: 12 }}
                  >
                    Voir
                  </a>
                )}
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
